<template>
  <div>
    <el-button tip="点绘制" icon="point" :place="pPlace" @click="startDraw('Point')">点</el-button>
    <el-button tip="线绘制" icon="polyline" :place="pPlace" @click="startDraw('LineString')" >线</el-button>
    <el-button tip="面绘制" icon="polygon" :place="pPlace" @click="startDraw('Polygon')" >面</el-button>
    <el-button tip="圆绘制" icon="circle" :place="pPlace" @click="startDraw('Circle')" >圆</el-button>
    <el-button tip="完成绘制" icon="done" :place="pPlace" @click="doneDraw()" >完成</el-button>
    <el-button tip="清除图形" icon="clear" :place="pPlace" @click="clearDraw()" >清除</el-button>
  </div>
</template>

<script>


import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import { ODraw } from "@/js/ol/POpenLayers.js";

export default {
  name: 'kw_gis_draw',
  props: {
    pMap: {
      default: null,
      require: true,
    },
    pPlace: {
      default: "right",
      require: false,
    },
    initSource:{
      default: null
    }
  },
  data() {
    let self = this;
    return {
      //图形类型数组
      drawingTypeInfo:[{name:"点",value:1},{name:"海量点",value:2},{name:"折线",value:3},{name:"多边形",value:4},{name:"圆形",value:5},{name:"标签",value:6}],
      mOlDraw: null,
    };
  },
  created() {
    
  },
  mounted() {
    this.mOlDraw = new ODraw(this.pMap,this.initSource);
    this.mOlDraw.init();
  },
  beforeDestroy(){
    
  },
  destroyed(){

  },
  watch:{
    ifRefresh:function(newVal){
      
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    startDraw(drawType) {
      this.mOlDraw.startDraw(drawType);
    },
    doneDraw() {
      this.mOlDraw.doneDraw();
      // .getGeometry().getCoordinates()  JSON.stringify(this.mOlDraw.mSource.getFeatures()
      this.$emit("getDrawDataInfo",this.mOlDraw);
    },
    clearDraw() {
      this.mOlDraw.clearDraw();
      
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noSelectedDrawType{
  box-shadow: rgb(0 0 0 / 35%) 2px 2px 3px;
   background: rgb(255, 255, 255);
   color: #000
}
.selectedDrawType{
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    cursor: pointer;
    text-size-adjust: none;
    background: rgb(142, 168, 224);
    box-shadow: rgba(0, 0, 0, 0.35) 2px 2px 3px;  
    color: #fff  
}
.tabDrawType{
    border-width: 1px;
    border-style: solid;
    border-color: rgb(139, 164, 220);   
    padding: 10px 10px;
    font: bold 12px / 1.3em arial, sans-serif;
    text-align: center;
    white-space: nowrap;
    border-radius: 0px 3px 3px 0px;
}
.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
}
</style>
